export type UpdateFn = (delta: number, elapsed: number) => void;

export class GameLoop {
  private running = false;
  private lastTime = 0;
  private elapsed = 0;
  private rafId = 0;
  private updateFn: UpdateFn;
  private renderFn: () => void;
  private targetFps: number;
  private frameInterval: number;
  private accumulator = 0;

  constructor(updateFn: UpdateFn, renderFn: () => void, targetFps = 60) {
    this.updateFn = updateFn;
    this.renderFn = renderFn;
    this.targetFps = targetFps;
    this.frameInterval = 1 / targetFps;
  }

  start() {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now() / 1000;
    this.tick();
  }

  stop() {
    this.running = false;
    cancelAnimationFrame(this.rafId);
  }

  private tick = () => {
    if (!this.running) return;
    this.rafId = requestAnimationFrame(this.tick);

    const now = performance.now() / 1000;
    let delta = now - this.lastTime;
    this.lastTime = now;

    // Clamp delta to 1 frame — prevents speed burst when tab pauses (e.g. screen recording)
    if (delta > this.frameInterval) delta = this.frameInterval;

    this.accumulator += delta;

    // Fixed timestep with interpolation
    while (this.accumulator >= this.frameInterval) {
      this.elapsed += this.frameInterval;
      this.updateFn(this.frameInterval, this.elapsed);
      this.accumulator -= this.frameInterval;
    }

    this.renderFn();
  };
}
